import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';

import { ButtonComponent, IconComponent, MenuItemComponent } from '@evc/web-components';

import { OrganizationsService } from '../../clients/core/organizations/organizations.service';
import { PlatformConfigService } from '../../features/config/config.service';
import { PlatformTranslatePipe } from '../../features/i18n/platform-translate.pipe';
import type { Guid } from '../../features/types/api-objects.type';

@Component({
  selector: 'evc-auth-license-capacity-modal',
  templateUrl: './auth-license-capacity-modal.html',
  styleUrl: './auth-license-capacity-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, PlatformTranslatePipe, MenuItemComponent],
})
export class AuthLicenseCapacityModalComponent {
  readonly #configService = inject(PlatformConfigService);
  readonly #organizationsService = inject(OrganizationsService);

  readonly orgSelected = output<Guid>();

  readonly organizations = this.#organizationsService.selectionItems;

  protected readonly homepage = computed(() => this.#configService.get('uris')?.homepage);
}
